import formatNewOptionGroupData from './formatNewOptionGroupData';
export default formatNewOptionGroupData;
